import { Link } from 'react-router-dom'
import {
  Box,
  CardActionArea,
  Grid,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material'

import useStyles from './styles'
import { FONTS, SPACES } from 'src/constants'
import { ReactNode } from 'react'
import { FirstPlaceIcon } from 'src/assets/icons/v2/FirstPlaceIcon'

interface ITopItemsStatistic {
  title?: string
  countType: 'likes' | 'views'
  index: number
  count?: number
  icon?: string
  link: string
  code: string
}

const TopItemsStatisticListItem = ({
  link,
  index,
  count,
  countType,
  title,
  icon,
  code,
}: ITopItemsStatistic) => {
  const classes = useStyles()
  const theme = useTheme()
  const isDesktop = useMediaQuery(theme.breakpoints.up('laptop'))

  return (
    <Grid container className={classes.boxContainer} mt={2}>
      <Grid
        container
        item
        xs={4}
        alignItems={isDesktop ? 'center' : 'flex-start'}
        minWidth={isDesktop ? '8rem' : '4rem'}
        spacing={SPACES.xxl}
      >
        <Grid item xs={1}>
          <Typography
            color={theme.palette.custom.grey2}
            fontWeight={isDesktop ? FONTS.WEIGHTS.bold : FONTS.WEIGHTS.medium}
            fontSize={isDesktop ? FONTS.SIZES.xl : FONTS.SIZES.s}
            textAlign={'left'}
            mt={0.1}
          >
            {index + 1}
          </Typography>
        </Grid>
        <Grid item xs>
          <Box display="flex" alignItems="baseline">
            <Typography
              fontWeight={FONTS.WEIGHTS.bold}
              fontSize={isDesktop ? FONTS.SIZES.xxxxl : FONTS.SIZES.m}
              color={isDesktop ? theme.palette.custom.primary : theme.palette.custom.black}
            >
              {count}
            </Typography>
            <Typography
              ml={SPACES.xxxs}
              fontWeight={FONTS.WEIGHTS.medium}
              fontSize={isDesktop ? FONTS.SIZES.default : FONTS.SIZES.xs}
              color={isDesktop ? theme.palette.custom.grey2 : theme.palette.custom.black}
            >
              {countType}
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Grid item xs={8}>
        <CardActionArea className={classes.boxActionWrapper} component={Link} to={link}>
          <Paper className={classes.box}>
            <img className={classes.icon} src={icon} alt={title} loading="lazy" />
            <div>
              <Typography fontSize="14px" fontWeight={700}>
                {title}
              </Typography>
              <Typography className={classes.cardCode} component="p">
                {'#' + code}
                &nbsp;
              </Typography>
            </div>
          </Paper>
        </CardActionArea>
      </Grid>
    </Grid>
  )
}

export { TopItemsStatisticListItem }
